import styled from 'styled-components';
import { Subtitle, constants, Paragraph } from '@cambridgeassessment/cambridge-ui';

export const StyledSubtitle = styled(Subtitle)`
  font-size: ${constants.LARGE};
  font-weight: normal;
  margin-bottom: 0px;
`;

export const StyledParagraph = styled(Paragraph)`
  max-width: 717px;
  line-height: 1.5;
`;
